import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { AuthService } from '../../services/auth.service';
import { CardDispenserService } from '../../services/card-dispenser.service';
import { filter } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyFormComponent } from '../../../pages/company/form/company-form.component';
import { CompanyModel } from '../../models/company.model';
import { UserModel } from '../../models/user.model';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ReceptionConfigModel } from '../../models/reception-config.model';
import { LockProviderConfigModel } from '../../models/lock-provider-config.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {

  private subscriptions: Subscription[] = [];

  iconSidebar;
  menuItems: Menu[];
  url: any;
  fileurl: any;
  environment: any = {};

  margin: any = 0;
  width: any = window.innerWidth;
  leftArrowNone: boolean = true;
  rightArrowNone: boolean = false;

  cardDispenser: any;
  receptionConfig: ReceptionConfigModel;
  lockProviderConfig: LockProviderConfigModel;

  currentUser: UserModel;

  constructor(
    private router: Router,
    public navServices: NavService,
    public layout: LayoutService,
    private modalService: NgbModal,
    private authService: AuthService,
    private cardDispenserService: CardDispenserService
  ) {
    this.environment = environment;
    this.initMenu();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  setNavActive(item) {
    this.menuItems.filter(menuItem => {
      if (menuItem !== item) {
        menuItem.active = false;
      }
      if (menuItem.children && menuItem.children.includes(item)) {
        menuItem.active = true;
      }
      if (menuItem.children) {
        menuItem.children.filter(submenuItems => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  toggletNavActive(item) {
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }

  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }

  private initMenu() {
    this.authService.currentUser.pipe(filter((user) => !!user)).subscribe((user) => {
      this.currentUser = user;
      this.setMenuItems();
      this.initReceptionConfig();
      this.initLockProviderConfig();
      this.initCardDispenserStatus();
    });
  }

  private initCardDispenserStatus() {
    if (!this.lockProviderConfig?.hasCardDispenser) {
      return;
    }

    const cardDispenserStatusSubscription = this.cardDispenserService.getStatus().subscribe((cardDispenser) => {
      this.cardDispenser = cardDispenser;
    });
    this.cardDispenserService.refreshStatus();
    this.subscriptions.push(cardDispenserStatusSubscription);
  }

  private initReceptionConfig() {
    this.receptionConfig = this.currentUser?.getReceptionConfig();
  }

  private initLockProviderConfig() {
    this.lockProviderConfig = this.currentUser?.getLockProviderConfig();
  }

  private setMenuItems() {
    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems.filter(item => !item.roles || item.roles?.includes(this.currentUser?.role));
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter(items => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }
            if (!items.children) { return false; }
            items.children.filter(subItems => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) { return false; }
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });
  }

  showCompanyModal() {
    const modalRef = this.modalService.open(CompanyFormComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.company = this.currentUser?.company;
    modalRef.componentInstance.showIsOnDisplayToggle = false;

    const savedSubscription = modalRef.componentInstance.companySaved.subscribe((company: CompanyModel) => {
      this.currentUser.company = company;
      modalRef.close();
    });

    const canceledSubscription = modalRef.componentInstance.canceled.subscribe(() => {
      modalRef.close();
    });

    this.subscriptions.push(savedSubscription);
    this.subscriptions.push(canceledSubscription);
  }

  get logoOnlyDarkUrl() {
    return this.receptionConfig?.logoOnlyDarkUrl || environment.logoOnlyDarkUrl;
  }

  get logoOnlyUrl() {
    return this.receptionConfig?.logoOnlyUrl || environment.logoOnlyUrl;
  }


}
